import { render, staticRenderFns } from "./MStoreButtons.vue?vue&type=template&id=2cec8a7d&"
import script from "./MStoreButtons.vue?vue&type=script&lang=ts&"
export * from "./MStoreButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports